import React from 'react'
import classNames from 'classnames'
import { Card } from 'react-bootstrap'

import styles from './AccordionCard.module.scss'

export const AccordionCard: React.FC<React.ComponentProps<Card>> = ({
  className,
  ...props
}) => <Card className={classNames(styles.root, className)} {...props} />
